const toggleFloatingContact = () => {
    if(document.querySelector('.kirinus-float-contact-link')){
        document.addEventListener('click', ev =>{
            if(!ev.target.closest('.kirinus-float-contact-link')) return;
            ev.preventDefault();
            let link = ev.target.closest('.kirinus-float-contact-link');
            let parent = link.parentElement;
            let target = parent.querySelector('.kirinus-float-contact-link--details');
            link.classList.toggle('kirinus-float-contact-link__active');
            target.classList.toggle('kirinus-float-contact-link--details__active');
        })
    }
}
export default toggleFloatingContact;